import { gql } from 'graphql-request';

export const createShopifyCollectionQuery = (handle, filter) => {
    return gql`{
  collectionByHandle(handle: "${handle}") {
    products(
    first: ${filter.first}
    last: ${filter.last}
    after: ${filter.after}
    before: ${filter.before}
    sortKey: ${filter.sortKey}
    reverse: ${filter.reverse}
    ) {
      nodes {
        handle
        id
        title
        isGiftCard
        availableForSale
        featuredImage {
            url(transform: {maxHeight: 90, maxWidth: 90})
            src
            altText
          }
        variants(first: 1) {
          nodes {
            id
            barcode
            priceV2 {
              amount
              currencyCode
            }
            price {
              amount
              currencyCode
            }
            compareAtPrice {
              currencyCode
              amount
            }
            compareAtPriceV2 {
              currencyCode
              amount
            }
            sku
            currentlyNotInStock
            availableForSale
            quantityAvailable
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
    title
  }
}
`
};
